import Vue from "vue";
import VueAnalytics from "vue-analytics";
import vuetify from "./plugins/vuetify";
import "./plugins/vue-progressbar";
import i18n from "./plugins/vueI18n";
import "./plugins/vue-filter";
import "./plugins/portal-vue";
import "./plugins/vue-moment";
import "./plugins/vue-toasted";
import "./plugins/sweetalert2";
import "./plugins/style";
import "./plugins/vue-google-charts";
import "./plugins/fontAwesome";
import "./plugins/vue-js-toggle-button";
import "./plugins/vue-date-time-picker";
import "./plugins/pos-component";
import "./plugins/vue-image-upload-resize";
import App from "./App.vue";
import router from "./router";
import store from "./plugins/vuex";
import "./registerServiceWorker";
import brandStore from "./modules/Brand/store";
import dragDialog from "@/directives/drag-dialog";

Vue.directive("drag-dialog", dragDialog);

Vue.config.productionTip = false;

const isProd =
  process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging";

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: !isProd,
  },
});

store.registerModule("brand", brandStore);

store.dispatch("brand/initBrand").then(() => {
  const theme = store.getters["brand/brandConfig"].theme;
  vuetify.framework.theme.themes.light = theme;
  vuetify.framework.theme.dark = false;
  localStorage.removeItem("admin-theme");
  // const vars = store.getters["brand/brandConfig"].themeVars;
  // if (vars) {
  //   Object.entries(vars).forEach(([key, value]) => {
  //     document.documentElement.style.setProperty(key, value);
  //   });
  // }
});

new Vue({
  router,
  i18n,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
